import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import NavbarContext from '../../navbar/context'
import {
  setIsBackButtonVisible,
  setIsCloseButtonVisible,
} from '../../navbar/context/action'
import MainLayout from '../../../shared/layout/main-layout/MainLayout'
import AppContext from '../../context'
import {
  AmountInfo,
  fetchStatusIs,
  LocationConfig,
  RequestStatus,
} from '../../../api/types'
import orderApi from '../../../api/services/OrderApi'
import {
  setAmount,
  setLocationConfig,
  setSelectedGoal,
  setSelectedOrganization,
} from '../../context/actions'
import AppSpinner from '../../../components/AppSpinner'
import ThanksView from './ThanksView'

export type ThanksParamsType = {
  orderId: string
}

const Thanks = () => {
  const { contextDispatch } = useContext(AppContext)
  const { contextDispatch: navbarContextDispatch } = useContext(NavbarContext)

  const [searchParams] = useSearchParams()

  const orderId = searchParams.get('orderId')

  const [requestStatus, setRequestStatus] = useState<RequestStatus>(
    RequestStatus.Idle
  )
  const { idle, pending, fulfilled } = fetchStatusIs(requestStatus)

  const navigate = useNavigate()

  useEffect(() => {
    setIsBackButtonVisible(navbarContextDispatch, false)
    setIsCloseButtonVisible(navbarContextDispatch, false)
  }, [navbarContextDispatch])

  const fetch = useCallback(async () => {
    if (!orderId) return
    setRequestStatus(RequestStatus.Pending)
    const result = await orderApi.getOrder(orderId)
    if (result) {
      setSelectedGoal(contextDispatch, result.data.goal)
      setSelectedOrganization(contextDispatch, result.data.organization)

      const amount: AmountInfo = {
        value: Number(result.data.amount / 100).toString(),
        txt: `${Number(result.data.amount / 100)} zł`,
        isPaid: result.data.isPaid,
      }

      setAmount(contextDispatch, amount)

      const data: LocationConfig = {
        logoId: result.data.logoId,
        backgroundId: result.data.backgroundId,
        locationCode: result.data.locationCode,
      }
      setLocationConfig(contextDispatch, data)

      setRequestStatus(RequestStatus.Fulfilled)
    } else {
      setRequestStatus(RequestStatus.Rejected)
    }
  }, [contextDispatch, orderId])

  useEffect(() => {
    if (idle) fetch()
  }, [fetch, idle])

  if (!orderId) {
    navigate('/blad')
    return null
  }

  return (
    <>
      <MainLayout withSideImage withNavbar withoutDecorations>
        <AppSpinner show={pending} />
        {fulfilled && <ThanksView />}
      </MainLayout>
    </>
  )
}

export default Thanks
